<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 会员记录
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="关键字" prop="keyword">
                <el-input v-model="searchform.keyword" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="奖励类型" prop="awardType">
                <el-select type="text" filterable v-model="searchform.awardType" style="width:100%">
                  <el-option
                    v-for="(item,index) in awardStuffTypelist"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="省/市/区" prop="provinceId">
                <el-col :span="8">
                  <el-select
                    style="width:90%"
                    clearable
                    v-model="searchform.provinceId"
                    placeholder="请选择省份"
                    @change="getcity(searchform.provinceId)"
                  >
                    <el-option
                      v-for="item in province"
                      :key="item.code"
                      :label="item.province"
                      :value="item.code"
                    />
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    style="width:90%"
                    clearable
                    v-model="searchform.cityId"
                    placeholder="请选择市"
                    @change="getdistrict(searchform.cityId)"
                  >
                    <el-option
                      v-for="item in city"
                      :key="item.code"
                      :label="item.city"
                      :value="item.code"
                    />
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    clearable
                    v-model="searchform.areaId"
                    style="width:100%"
                    placeholder="请选择区"
                  >
                    <el-option
                      v-for="item in district"
                      :key="item.code"
                      :label="item.area"
                      :value="item.code"
                    />
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="领取时间" prop="datelist">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.datelist"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['supervise_select']"
              >搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{title}}</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="openid" label="OpenID" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="awardTypename" label="奖励类型" min-width="140"></el-table-column>
            <el-table-column prop="userName" label="消费者昵称" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userPhone" label="消费者手机" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="awardSum" label="领取总额" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="provinceName" label="省" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cityName" label="市" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="areaName" label="区" min-width="80" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="searchform.rows"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { searchawardsummaries } from "@/api/market/viprecord";
import { findByParentCode } from "@/api/orgin";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
    // 获取省下拉
    findByParentCode().then(response => {
      this.province = response.data;
    });
  },
  data() {
    return {
      //基础数据
      title: "奖励排行统计",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      province: [],
      city: [],
      district: [],
      //分页数据
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      awardStuffTypelist: [
        // 奖励类型
        {
          value: 0,
          label: "红包"
        },
        {
          value: 1,
          label: "积分"
        },
        {
          value: 2,
          label: "实物"
        },
        {
          value: 3,
          label: "优惠卷"
        }
      ],
      searchform: {
        provinceId: null,
        cityId: null,
        areaId: null,
        awardType: null,
        datelist: [],
        userType: 1,
        keyword: null,
        page: 1,
        rows: 10
      },
      value: true
    };
  },
  methods: {
    // 获取市
    getcity(code) {
      this.city = [];
      this.searchform.cityId = "";
      this.searchform.areaId = "";
      findByParentCode({ paretnCode: code }).then(response => {
        this.city = response.data;
        this.editVisible = true;
      });
    },
    // 获取区
    getdistrict(code) {
      this.district = [];
      this.searchform.areaId = "";
      findByParentCode({ paretnCode: code }).then(response => {
        this.district = response.data;
        this.editVisible = true;
      });
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      searchawardsummaries(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (Number(obj[i].awardType)) {
          case 0:
            obj[i].awardTypename = "红包";
            break;
          case 1:
            obj[i].awardTypename = "积分";
            break;
          case 2:
            obj[i].awardTypename = "实物";
            break;
          case 3:
            obj[i].awardTypename = "优惠卷";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    changeSwitch(row, state) {
      console.log(row);
      updatestate({
        uuid: row.userUuid,
        state: row.state
      }).then(response => {});
    },
    search() {
      this.currentPage = 1;
      this.Tabledata({
        provinceId: this.searchform.provinceId,
        cityId: this.searchform.cityId,
        areaId: this.searchform.areaId,
        awardType: this.searchform.awardType,
        keyword: this.searchform.keyword,
        userType: this.searchform.userType,
        beginDate:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endDate:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        page: 1,
        rows: this.searchform.rows
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.searchform.cityId = null;
      this.searchform.areaId = null;
    },
    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page;
      this.Tabledata({
        provinceId: this.searchform.provinceId,
        cityId: this.searchform.cityId,
        areaId: this.searchform.areaId,
        awardType: this.searchform.awardType,
        keyword: this.searchform.keyword,
        userType: this.searchform.userType,
        beginDate:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endDate:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        page: this.searchform.page,
        rows: this.searchform.rows
      });
      console.log(page);
    },
    //分页每页显示条数事件
    pagesize(rows) {
      this.searchform.rows = rows;
      this.search();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        rows: this.total_count,
        ifScanSuccess: this.searchform.ifScanSuccess,
        qrcode: this.searchform.qrcode,
        batchno: this.searchform.batchno,
        dealer_name: this.searchform.dealer_name,
        screateTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        ecreateTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      };
      check(obj).then(response => {
        this.packdate(response.data.list);
        this.tableDataDownload = response.data.list;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "稽查人姓名",
            "稽查人编码",
            "查询日期",
            "查询地点",
            "查询次数",
            "查询方式",
            "产品名称",
            "批次号",
            "防伪码",
            "出库日期",
            "运单号",
            "送达方名称",
            "送达方地址",
            "查询结果"
          ];
          const filterVal = [
            "employee_name",
            "account_name",
            "create_time",
            "address",
            "qrcodeqty",
            "query_method",
            "product_name",
            "batchno",
            "qrcode",
            "freight_bill_code_time",
            "freight_bill_code",
            "dealer_name",
            "addr",
            "ifflee_good"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>